import React, { useEffect } from 'react';
import Header from './Header';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  // Add error boundary for the entire app
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      console.error('Global error caught:', event.error);
      // You could implement more sophisticated error handling here
    };

    window.addEventListener('error', handleError);
    return () => window.removeEventListener('error', handleError);
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-slate-50 dark:bg-slate-900 text-slate-800 dark:text-slate-200">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-6 sm:px-6 sm:py-8">
        {children}
      </main>
      
      <footer className="bg-white dark:bg-slate-800 shadow-sm py-4 mt-auto">
        <div className="container mx-auto px-4 sm:px-6 text-center text-sm text-slate-600 dark:text-slate-400">
          <p>© {new Date().getFullYear()} BudFi - Budget & Finance Manager</p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;